import {
  useEffect,
  useRef,
  useState
} from 'react'
import { Popup } from 'react-leaflet'
import { useSelector } from 'react-redux'
import {
  Box,
  IconButton,
  Stack,
  Text
} from '@chakra-ui/react'
import { LoadingSpinier } from 'common/Loading'
import { ArrowIcon } from 'assets/icons'
import { markersSelectors } from 'store'
import { REJECTED } from 'utils/constants'
import { isNotMobile } from 'utils/helpers'
import { COLORS } from 'utils/styles'

import { Content } from 'components/Content/Map/Markers/EventMarkerPopup/Content'
import { StyledModalContainer } from './styled'

export const EventMarkerPopup = ({
  eventMarkerPopupCoords,
  handleClosePopup
}) => {
  const EventPopupRef = useRef(null)

  const {
    eventData,
    getEventDataStatus
  } = useSelector(markersSelectors)

  const [hoveringChevron, setHoveringChevron] = useState(false)
  const [outAnimation, setOutAnimation] = useState(false)
  const getPopupHeight = () => (window.innerHeight - 150) + 'px'

  const chevronDirection = (type) => {
    if (
      (
        isNotMobile()
        || sessionStorage.getItem('eventid')
      )
      && type === 'icon'
    ) {
      return 'rotate(-90deg)'
    }

    if (
      (
        isNotMobile()
        || sessionStorage.getItem('eventid')
      )
      && type === 'text'
    ) {
      return 'rotate(90deg)'
    }

    return 'rotate(180deg)'
  }

  const closePopupAnimation = () => {
    setOutAnimation(true)
    setTimeout(() => handleClosePopup(), 850)
  }

  useEffect(() => {
    if (getEventDataStatus === REJECTED) {
      closePopupAnimation()
    }
  }, [getEventDataStatus])

  return (
    <Stack
      id="custom-popup-overlay-event"
      width="100%"
      height="130%"
      zIndex="399"
      position="fixed"
      marginTop="-50px"
      onClick={() => closePopupAnimation()}
    >
      <Popup
        ref={EventPopupRef}
        position={eventMarkerPopupCoords}
        maxWidth={5000}
        minWidth={300}
        autoClose
        offset={[0, (-window.innerHeight - 720) / 100]}
        closeButton={false}
        closeOnClick={false}
        id="popup-event-id"
      >
        {eventData === null ? (
          <StyledModalContainer style={{ height: 'auto' }}>
            <Box width="100%" height="170px">
              <LoadingSpinier />
            </Box>
          </StyledModalContainer>
        ) : (
          <Box
            style={{
              display: 'flex',
              justifyContent: 'center',
              marginLeft: 'auto',
              marginRight: 'auto',
              height: getPopupHeight(),
              overflowY: 'clip',
              position: 'relative'
            }}
          >
            <StyledModalContainer
              initial={{
                top: outAnimation ? 0 : window.innerHeight
              }}
              animate={{
                top: outAnimation ? window.innerHeight : 0
              }}
              transition={{
                type: 'tween',
                duration: 0.8
              }}
              onClick={(e) => e.stopPropagation()}
              style={{
                height: getPopupHeight(),
                fontSize: '16px',
                position: 'relative'
              }}
            >
              <Stack
                alignItems="center"
                justifyContent="center"
                direction="row"
                p="0px 5px"
                background={COLORS.goldGradientRightToLeft}
                minHeight="48px"
                maxHeight="48px"
                borderRadius="10px 10px 0 0"
                marginTop="-1px"
                position="sticky"
                top="-0.2"
                marginBottom="-7px"
                zIndex="299"
              >
                <Text
                  maxWidth="70%"
                  fontSize="24px"
                  textAlign="center"
                >
                  Event
                </Text>

                <IconButton
                  id="event-modal-back-button"
                  outline="none"
                  boxShadow="none"
                  position="absolute"
                  right="1.5"
                  background="unset"
                  transform={chevronDirection('icon')}
                  transition="none"
                  css={{
                    ':focus': {
                      outline: 'none',
                      boxShadow: 'none'
                    }
                  }}
                  icon={(
                    <>
                      <Text
                        fontWeight="300"
                        transform={chevronDirection('text')}
                        display={hoveringChevron ? 'flex' : 'none'}
                      >
                        Exit
                      </Text>

                      <Stack display={hoveringChevron ? 'none' : 'flex'}>
                        <ArrowIcon height="15px" />
                      </Stack>
                    </>
                  )}
                  _hover={{ background: COLORS.gold_hover }}
                  onClick={() => {
                    closePopupAnimation()
                    setHoveringChevron(false)
                  }}
                  onPointerEnter={(e) => {
                    if (e.pointerType === 'mouse') {
                      setHoveringChevron(true)
                    }
                  }}
                  onPointerLeave={(e) => {
                    if (e.pointerType === 'mouse') {
                      setHoveringChevron(false)
                    }
                  }}
                />
              </Stack>

              <Content />
            </StyledModalContainer>
          </Box>
        )}
      </Popup>
    </Stack>
  )
}
